import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { captureTrafficSourceIfAny } from "./lib/brand";

// Capture UTM & referrer once per session on first import
if (typeof window !== "undefined") {
  captureTrafficSourceIfAny();
}

import Home from "./pages/public/Home";
import HouseList from "./pages/public/HouseList";
import HouseDetail from "./pages/public/HouseDetail";
import About from "./pages/public/About";
import Contact from "./pages/public/Contact";
import GuestReservation from "./pages/public/GuestReservation";
import Legal from "./pages/public/Legal";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminShell from "./components/AdminShell";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminReservations from "./pages/admin/AdminReservations";
import AdminCalendar from "./pages/admin/AdminCalendar";
import AdminHouses from "./pages/admin/AdminHouses";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminTasks from "./pages/admin/AdminTasks";
import AdminBrand from "./pages/admin/AdminBrand";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSecurity from "./pages/admin/AdminSecurity";
import AdminAudit from "./pages/admin/AdminAudit";
import AdminForceChangePassword from "./pages/admin/AdminForceChangePassword";
import AdminInstitutional from "./pages/admin/AdminInstitutional";
import AdminContracts from "./pages/admin/AdminContracts";
import AdminContractTemplate from "./pages/admin/AdminContractTemplate";
import AdminChecklists from "./pages/admin/AdminChecklists";
import AdminTrash from "./pages/admin/AdminTrash";
import AdminPriceLabs from "./pages/admin/AdminPriceLabs";
import AdminSeasonalPricing from "./pages/admin/AdminSeasonalPricing";
import AdminForgotPassword from "./pages/admin/AdminForgotPassword";
import AdminResetPassword from "./pages/admin/AdminResetPassword";
import ContractFill from "./pages/public/ContractFill";
import ContractReview from "./pages/public/ContractReview";
import GuestPix from "./pages/public/GuestPix";
import ReservaSegura from "./pages/public/ReservaSegura";
import ChecklistFill from "./pages/public/ChecklistFill";
import { AdminGuestsList, AdminGuestProfile } from "./pages/admin/AdminGuests";

import { isLoggedIn } from "./lib/auth";

function RequireAuth({ children }) {
  if (!isLoggedIn()) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/casas" element={<HouseList />} />
        <Route path="/casas/:slug" element={<HouseDetail />} />
        <Route path="/sobre" element={<About />} />
        <Route path="/contato" element={<Contact />} />
        <Route path="/reserva/:token" element={<GuestReservation />} />
        <Route path="/reserva/:token/pix" element={<GuestPix />} />
        <Route path="/reserva-segura" element={<ReservaSegura />} />
        <Route path="/politica-privacidade" element={<Legal kind="privacy" />} />
        <Route path="/termos" element={<Legal kind="terms" />} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/esqueci-senha" element={<AdminForgotPassword />} />
        <Route path="/admin/redefinir-senha/:token" element={<AdminResetPassword />} />
        <Route path="/contrato/completar/:token" element={<ContractFill />} />
        <Route path="/contrato/assinar/:token" element={<ContractFill />} />
        <Route path="/contrato/:token" element={<ContractReview />} />
        <Route path="/checkin/:token" element={<ChecklistFill />} />
        <Route path="/checkout/:token" element={<ChecklistFill />} />
        <Route path="/admin/trocar-senha" element={<RequireAuth><AdminForceChangePassword /></RequireAuth>} />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <AdminShell />
            </RequireAuth>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="reservas" element={<AdminReservations />} />
          <Route path="hospedes" element={<AdminGuestsList />} />
          <Route path="hospedes/:email" element={<AdminGuestProfile />} />
          <Route path="calendario" element={<AdminCalendar />} />
          <Route path="casas" element={<AdminHouses />} />
          <Route path="pagamentos" element={<AdminPayments />} />
          <Route path="tarefas" element={<AdminTasks />} />
          <Route path="marca" element={<AdminBrand />} />
          <Route path="institucional" element={<AdminInstitutional />} />
          <Route path="contratos" element={<AdminContracts />} />
          <Route path="contratos/modelo" element={<AdminContractTemplate />} />
          <Route path="checkin-checkout" element={<AdminChecklists />} />
          <Route path="lixeira" element={<AdminTrash />} />
          <Route path="integracoes/pricelabs" element={<AdminPriceLabs />} />
          <Route path="precificacao" element={<AdminSeasonalPricing />} />
          <Route path="usuarios" element={<AdminUsers />} />
          <Route path="auditoria" element={<AdminAudit />} />
          <Route path="seguranca" element={<AdminSecurity />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
